import {combineReducers} from 'redux';
import * as navigationReducer from './navigation'
import * as caseReducer from './cases'
export default combineReducers(Object.assign({},navigationReducer,caseReducer));



// WEBPACK FOOTER //
// ./src/reducers/index.js